import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/Service/auth.service';
import { LoadingService } from 'src/app/Service/loading.service';
import { UserService } from 'src/app/User/Service/user.service';
import { Meta , Title} from '@angular/platform-browser';

enum SecurityTab {
  SecurityFirst = 0,
  EaseOfUse = 1,
  RealSupport = 2,
}

@Component({
    selector: 'app-aboutus',
    templateUrl: './aboutus.component.html',
    styleUrls: ['./aboutus.component.css'],
    standalone: false
})
export class AboutusComponent implements OnInit {
  @ViewChild('pricing') pricing;
  @ViewChild('aboutUsPopUp') aboutUsPopUp;

  public securityType: any;
  currentSecurityType: any;
  currentLogoInfo: any;

  constructor(
    public auth: AuthService,
    public userService: UserService,
    private loader: LoadingService,
    private modalService: NgbModal,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private meta: Meta,
    private title:Title
  ) {
    this.title.setTitle("About US|Family Central");
    this.meta.addTag({ name: 'description', content: 'Learn about our team and what inspired our founder to create Family Central.' });
    this.securityType = SecurityTab;
    this.currentSecurityType = this.securityType.SecurityFirst;
  }
  ngOnInit(): void {
    
    this.loader.HideLoading();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const fragment = this.activatedRoute.snapshot.fragment;
        if (fragment) {
          this.scrollToSection(fragment);
        }
      }
    });
  }


  scrollToSection(fragment: string): void {
    setTimeout(() => {
      const element = document.getElementById(fragment);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      }
    }, 0);
  }

  onClose() {
    this.modalService.dismissAll();
  }
}
